import { Image } from "@chakra-ui/react";
import React from "react";
import logo from "./trusted-advisor-logo.png";

export const TrustedAdvisorLogo = () => {
  return <Image objectFit="contain" src={logo} alt="ACSISS Adviser Logo" />;
};
